__turbopack_context__.v({
  "background": "Upfront-module__-8MyKq__background",
  "buttonHover": "Upfront-module__-8MyKq__buttonHover",
  "focusOutline": "Upfront-module__-8MyKq__focusOutline",
});
